import { C } from '../actions/index';
import 'utils/constants';

export const initialSignupState = {
  modalOpen: false,
  signupError: null,
  signupPending: false,
  errorHighlight: null
};

export const signup = (state = initialSignupState, action) => {
  switch (action.type) {
    case C.OPEN_SIGNUP_MODAL:
      return Object.assign({}, state, { modalOpen: true });
    case C.CLOSE_SIGNUP_MODAL:
      return Object.assign({}, state, {
        modalOpen: false,
        signupError: null,
        errorHighlight: null
      });
    case C.SUBMIT_SIGNUP:
      return Object.assign({}, state, {
        signupError: null,
        signupPending: true,
        errorHighlight: null
      });
    case C.SUBMIT_SIGNUP_FAIL:
      return Object.assign({}, state, {
        signupError: action.error,
        signupPending: false,
        errorHighlight: action.payload
      });
    case C.SUBMIT_SIGNUP_SUCCESS:
      return Object.assign({}, state, {
        signupError: null,
        signupPending: false,
        errorHighlight: null,
        modalOpen: false
      });
    case C.SUBMIT_STYLE_QUIZ_SUCCESS:
      return Object.assign({}, state, {
        signupError: null,
        signupPending: false,
        errorHighlight: null,
        modalOpen: false
      });
    default:
      return state;
  }
};
